import { render, staticRenderFns } from "./AddPackagePrice.vue?vue&type=template&id=51d085f0&"
import script from "./AddPackagePrice.vue?vue&type=script&lang=js&"
export * from "./AddPackagePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports